import React,{useState, useEffect} from 'react';
import '../allJava/Jcss.css';
import Sides from '../Bars/Javasidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";

function Jvar(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>
    <Sides/>
    <Helmet>
 
 <title>Java Variables tutorial For Beginners</title>
<meta name="description" content="Java Variable tutorial for beginners Variables value can be changed,A variables is defined by the combination of an identifier,data types and an initializer." />
<meta name="keywords" content="codeexampler,programming language,tutorial for begineers,java variable,java variables,java variable types
,java variable declaration,java variable scope,java variable naming convention,java variable arguments,java variable name,java variable definition
,java variable assignment,java variables and data types,java variable declaration syntax,java variable initialization best practices,java variable rules,java variable types and sizes" />
<link rel="canonical" href="https://www.codeexampler.com/java-variables" />
</Helmet>

<div className='lg:pl-56'>


    <h1 className="m-4 mh1">Variables in java</h1>
    <div className="first">
        
        <a href="/java-types-of-variables">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    <p className="mt-4 para">
    1, Variable is the name of a memory location  in which we can store the value <br/>
2, The variable value can be change<br/>
3, A variable is defined by combining an identifier, data types, and an initializer.<br/>
4, The first character in the variable name must be an alphabet, underscore, a digit, or a dollar sign. <br/>
5, All variables have a scope<br/>
6, The identifier is the name of the Variable<br/>
7, Commas or blanks are not used inside a variable name

    </p>
  

<h2 className="headings">Java Variable Declaration Syntax :</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        
          {"\n"}          
    <span className="qwerty-2">Type </span>
    <span className="qwerty-4">Variable name;</span>
    {"\n"}
    <span className="qwerty-2">int </span>
    <span className="qwerty-3">is a type</span>
    {"\n"}
    <span className="qwerty-4">a </span>
    <span className="qwerty">,</span>
    <span className="qwerty-4">b </span>
    <span className="qwerty">and </span>
    <span className="qwerty-4">a</span>
    <span className="qwerty">*</span>
    <span className="qwerty-4">b</span>
    <span className="qwerty-3"> is a variable-name</span>
    {"\n"}
    

 
  {"\n"}
   </code>
      </pre>        
    </div>





<h2 className="headings">Java variable declaration syntax Rules:</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        
          {"\n"}          
    <span className="qwerty-2">Type </span>
    <span className="qwerty-4">Variable name</span>
    <span className="qwerty">:</span>
    {"\n"}
    <span className="qwerty-2">int </span>
    <span className="qwerty-4">Roll_No;</span>
    <span className="qwerty-5">{`//Roll_No declare a Variable`}</span>
    {"\n"}
    <span className="qwerty-6">float </span>
    <span className="qwerty-4">Percentage;</span>
    <span className="qwerty-5">{`//Percentage declare a Variable`}</span>
    {"\n"}
    <span className="qwerty-4">Roll_No</span>
    <span className="qwerty">=</span>
    <span className="qwerty-1">40 ;</span>
    <span className="qwerty-5">{`//assigns value in variable `}</span>
    {"\n"}
    <span className="qwerty-4">Precentege</span>
    <span className="qwerty">=</span>
    <span className="qwerty-1">40.80;</span>
    <span className="qwerty-5">{`//assigns value in variable`}</span>
    {"\n"}


 
  {"\n"}
    
    
    
    
    
       
        </code>
      </pre>        
    </div>
    

<h2  className="mt-4 mh2">How to Declare a variables in Java:</h2>
<p className="para mt-3">The Variables are declared in various types. </p>




    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        
          {"\n"}          
    <span className="qwerty-2">int </span>
    <span className="qwerty-4">abc;</span>
    <span className="qwerty-5">{`// this declare a variable`}</span>
    {"\n"}
    <span className="qwerty-2">int </span>
    <span className="qwerty-4">abc;</span>
    <span className="qwerty-5">{`//  (abc and a_bc are a variable)`}</span>
    {"\n"}
    <span className="qwerty-2">int </span>
    <span className="qwerty-4">a</span>
    <span className="qwerty">,</span>
    <span className="qwerty-4">b</span>
    <span className="qwerty">,</span>
    <span className="qwerty-4">x</span>
    <span className="qwerty">,</span>
    <span className="qwerty-4">z;</span>
    <span className="qwerty-5">{`// (a,b,x,z) are a variable`}</span>
    
    {"\n"}
    <span className="qwerty-2">byte </span>
    <span className="qwerty-4">a1</span>
    <span className="qwerty">=</span>
    <span className="qwerty-1">40;</span>
    <span className="qwerty-5">{`//initialize a.`}</span>
    {"\n"}
    <span className="qwerty-7">double </span>
    <span className="qwerty-4">a2</span>
    <span className="qwerty">=</span>
    <span className="qwerty-1">40.80 ;</span>
    <span className="qwerty-5">{`//like a float`}</span>
    {"\n"}
    <span className="qwerty-3">Char </span>
    <span className="qwerty-4">a3</span>
    <span className="qwerty">=</span>
    <span className="qwerty-1">“ram”;</span>
    <span className="qwerty-5">{`//a variable gain value ( ram )`}</span>
    {"\n"}


 
  {"\n"}
    
    
    
    
    
       
        </code>
      </pre>        
    </div>


<h2 className="mt-4 mh2">Q-Addition of Variables Java Example?</h2>

    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        
        {"\n"}          
    <span className="qwerty-2">int </span>
    <span className="qwerty-4">a</span>
    <span className="qwerty">,</span>
    <span className="qwerty-4">b</span>
    <span className="qwerty">,</span>
    <span className="qwerty-4">c</span>
    <span className="qwerty">,</span>
    <span className="qwerty-4">d;</span>
    {"\n"}
    
    <span className="qwerty-4">a</span>
    <span className="qwerty">=</span>
    <span className="qwerty-1">10; </span>
    <span className="qwerty-4">b</span>
    <span className="qwerty">=</span>
    <span className="qwerty-1">20; </span>
    <span className="qwerty-4">c</span>
    <span className="qwerty">=</span>
    <span className="qwerty-1">30; </span>
    <span className="qwerty-4">d</span>
    <span className="qwerty">=</span>
    <span className="qwerty-1">40;</span>
    {"\n"}
  <span className="qwerty-2">System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">a</span>
    <span className="qwerty">+</span>
    <span className="qwerty-4">b</span>
    <span className="qwerty">+</span>
    <span className="qwerty-4">c</span>
    <span className="qwerty">+</span>
    <span className="qwerty-4">d</span>
      <span className="qwerty-1">);</span>
      {"\n"}{"\n"}
    
    
       
        </code>
      </pre>        
    </div>
    
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-3">&nbsp;100</span>          
          {"\n"} 
          
       
            </code>{"   "}
            </pre>
      </div>
    </div>


<h2 className="mt-4 mh2">Q-Variable increment values in Java?
</h2>

    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        
        {"\n"}          
    <span className="qwerty-2">int </span>
    <span className="qwerty-4">a</span>
    <span className="qwerty">=</span>
    <span className="qwerty-1">10;</span>
    <span className="qwerty-10">{`// a is a Variable `}</span>
    {"\n"}

    
    <span className="qwerty-4">a</span>
    <span className="qwerty">+=</span>
    <span className="qwerty-1">40; </span>
    {"\n"}
    <span className="qwerty-4">a</span>
    <span className="qwerty">=</span>
    <span className="qwerty-4">a</span>
    <span className="qwerty">+</span>
    <span className="qwerty-1">20; </span>
    {"\n"}
  <span className="qwerty-2">System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">a</span>
      <span className="qwerty-1">);</span>
      {"\n"}{"\n"}
    
    
       
        </code>
      </pre>        
    </div>
    
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-3">&nbsp;70</span>          
          {"\n"} 
          
       
            </code>{"   "}
            </pre>
      </div>
    </div>

<br/>

<h2 className="headings">Q-Create a variable and store a no inside this variable and print output?</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        
        {"\n"}          
    <span className="qwerty-2">int </span>
    <span className="qwerty-4">a;</span>
    {"\n"} 
    <span className="qwerty-4">a</span>
    <span className="qwerty">=</span>
    <span className="qwerty-1">40;</span>
    {"\n"}{"\n"}
    <span className="qwerty-5">&nbsp;OR</span>
    {"\n"}{"\n"}
    <span className="qwerty-2">int </span>
    <span className="qwerty-4">a</span>
    <span className="qwerty">=</span>
    <span className="qwerty-1">40; </span>
    {"\n"}
  <span className="qwerty-2">System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">a</span>
      <span className="qwerty-1">);</span>
      {"\n"}{"\n"}
    
    
       
        </code>
      </pre>        
    </div>
    
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-3">&nbsp;40</span>          
          {"\n"} 
          
       
            </code>{"   "}
            </pre>
      </div>
    </div>

<h2 className="mt-4 mh2">Create Variable String Type: </h2>

<br/>

<h2 className="headings">Q-Create a string variable and store a no inside string type variable and print output?</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        
        {"\n"}          
    <span className="qwerty-2">&nbsp;String </span>
    <span className="qwerty-4">a</span>
    <span className="qwerty">=</span>
    <span className="qwerty-1">"Ram";</span>
    {"\n"}          
    <span className="qwerty-2">&nbsp;String </span>
    <span className="qwerty-4">b</span>
    <span className="qwerty">=</span>
    <span className="qwerty-1">"Lakshman";</span>
    {"\n"}{"\n"}
    <span className="qwerty-5">&nbsp;OR</span>
    {"\n"}{"\n"}
    <span className="qwerty-2">&nbsp;String </span>
    <span className="qwerty-4">a</span>
    <span className="qwerty">,</span> 
    <span className="qwerty-4">b;</span>
    {"\n"}
    <span className="qwerty-4">&nbsp;a</span>
    <span className="qwerty">=</span>
    <span className="qwerty-1">"Ram"; </span>
    {"\n"}
    <span className="qwerty-4">&nbsp;b</span>
    <span className="qwerty">=</span>
    <span className="qwerty-1">"Lakshman"; </span>
    {"\n"}
  <span className="qwerty-2">&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">a</span>
        <span className="qwerty-8">+</span>
        <span className="qwerty-4">b</span>
      <span className="qwerty-1">);</span>
      {"\n"}{"\n"}
    
    
       
        </code>
      </pre>        
    </div>
    
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-3">&nbsp;RamLakshman</span>          
          {"\n"} 
          
       
            </code>{"   "}
            </pre>
      </div>
    </div>


<h2 className="mt-4 mh2"> Another string type  example</h2>

<br/>

<h2 className="headings">Q-Create a string variable and store a no inside string data type variable and print output?</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        
          {"\n"}
 
          <span className="qwerty-10">class</span>
          <span className="qwerty-4"> Ram</span>
          
          {"\n"}
          <span className="qwerty-3">&#123; </span>
          {"\n"}
           
            <span className="qwerty-7">&nbsp; &nbsp;public </span>
          <span className="qwerty">static </span>
          <span className="qwerty-3">void </span>
          <span className="qwerty-8">main</span>
          <span className="qwerty-1">(</span>
          <span className="qwerty-2">String</span>
          <span className="qwerty-1">[] </span>
          <span className="qwerty-1">args</span>
          <span className="qwerty-1">) </span>
          {"\n"}
          <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>          
      {"\n"}
      <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;String </span>
    <span className="qwerty-4">a</span>
    <span className="qwerty-8"> ,</span>
    <span className="qwerty-4">b</span>
    <span className="qwerty-8"> ,</span>
    <span className="qwerty-4">c;</span>
 
  {"\n"}
  <span className="qwerty-4">&nbsp;&nbsp;&nbsp;&nbsp;a</span>
    <span className="qwerty-8"> = </span>
    <span className="qwerty-1">"Ram";</span>
    {"\n"} 
    <span className="qwerty-4">&nbsp;&nbsp;&nbsp;&nbsp;b</span>
    <span className="qwerty-8"> = </span>
    <span className="qwerty-1">"Lakshman";</span>
    {"\n"} 
    <span className="qwerty-4">&nbsp;&nbsp;&nbsp;&nbsp;c</span>
    <span className="qwerty-8"> = </span>
    <span className="qwerty-1">"My Name is CodeExampler 160208";</span>

  {"\n"} 
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">a</span>
        <span className="qwerty-8">+</span>
        <span className="qwerty-4">""</span>
        <span className="qwerty-8">+</span>
        <span className="qwerty-4">b</span>
        <span className="qwerty-8">+</span>
        <span className="qwerty-4">""</span>
        <span className="qwerty-8">+</span>
        <span className="qwerty-4">c</span>
      <span className="qwerty-1">);</span>
      {"\n"}
  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>


 
 



{"\n"}
          <span className="qwerty-3">&#125; </span>
            {"\n"}
    
    
    
    
    
       
        </code>
      </pre>        
    </div>
    
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-4">&nbsp;Ram </span> 
          <span className="qwerty-5">Lakshman </span> 
          <span className="qwerty-3">My name is CodeExampler 160208</span>          
          {"\n"}
          
       
            </code>{"   "}
            </pre>
      </div>
    </div>

<h2 className="mt-4 mh2">Constant:</h2>

<p className="mt-4 para">Constant is used when you store a value inside a variable, but use Constant after you can’t overwrite the existing deal.
</p>

  <h1 className="mt-5">  </h1>
  <div className="back">
       
        <a href="/java-types-of-variables">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
        </div>
        </div>
)

}
export default Jvar;